import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as calculatedVariableActions from './calculated-variable.actions';
import { CalculatedVariable } from 'src/app/models/calculated-variable';

export interface CalculatedVariableState extends EntityState<CalculatedVariable> {
  loadingCalculatedVariables: boolean;
  calculatedVariablesLoaded: boolean;
  selectedCalculatedVariable: CalculatedVariable;
}

export const calculatedVariableAdapter: EntityAdapter<any> = createEntityAdapter<CalculatedVariable>({});

export const initialCalculatedVariableState: CalculatedVariableState = calculatedVariableAdapter.getInitialState({
  loadingCalculatedVariables: false,
  calculatedVariablesLoaded: false,
  selectedCalculatedVariable: null,
});

export const reducer = createReducer(
  initialCalculatedVariableState,
  on(calculatedVariableActions.getCalculatedVariablesForStudy, (state) => {
    return {
      ...state,
      loadingCalculatedVariables: true,
      calculatedVariablesLoaded: false,
    };
  }),
  on(calculatedVariableActions.getCalculatedVariablesForStudySuccess, (state, { calculatedVariablesForStudy }) => {
    return calculatedVariableAdapter.setAll(calculatedVariablesForStudy, {
      ...state,
      loadingCalculatedVariables: false,
      calculatedVariablesLoaded: true,
    });
  }),
  on(calculatedVariableActions.getCalculatedVariablesForStudyError, (state) => {
    return {
      ...state,
      loadingCalculatedVariables: false,
      calculatedVariablesLoaded: false,
    };
  }),
  on(calculatedVariableActions.getCalculatedVariablesForModuleSuccess, (state, { calculatedVariablesForModule }) => {
    return calculatedVariableAdapter.setAll(calculatedVariablesForModule, {
      ...state,
      loadingCalculatedVariables: false,
      calculatedVariablesLoaded: true,
    });
  }),

  on(calculatedVariableActions.getCalculatedVariablesForModuleError, (state) => {
    return {
      ...state,
      loadingCalculatedVariables: false,
      calculatedVariablesLoaded: false,
    };
  }),
  on(calculatedVariableActions.createCalculatedVariableSuccess, (state, { createdCalculatedVariable }) => {
    return calculatedVariableAdapter.addOne(createdCalculatedVariable, {
      ...state,
    });
  }),
  on(calculatedVariableActions.updateCalculatedVariableSuccess, (state, { updatedCalculatedVariable }) => {
    return calculatedVariableAdapter.updateOne(
      {
        id: updatedCalculatedVariable?.id,
        changes: updatedCalculatedVariable,
      },
      {
        ...state,
      }
    );
  }),
  on(calculatedVariableActions.deleteCalculatedVariableSuccess, (state, { deletedCalculatedVariable }) => {
    return calculatedVariableAdapter.removeOne(deletedCalculatedVariable.id, {
      ...state,
    });
  })
);

export function calculatedVariableReducer(state: CalculatedVariableState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = calculatedVariableAdapter.getSelectors();
